import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAlertDialogState } from '../../types/store';

const initialState: IAlertDialogState = {
  open: false,
  title: '',
  description: '',
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  onConfirm: undefined,
  onCancel: undefined,
};

const alertDialogSlice = createSlice({
  name: 'alertDialog',
  initialState,
  reducers: {
    showAlertDialog: (state, action: PayloadAction<Omit<IAlertDialogState, 'open'>>) => {
      state.open = true;
      state.title = action.payload.title;
      state.description = action.payload.description;
      state.confirmText = action.payload.confirmText ?? 'Confirm';
      state.cancelText = action.payload.cancelText ?? 'Cancel';
      state.onConfirm = action.payload.onConfirm;
      state.onCancel = action.payload.onCancel;
    },
    closeAlertDialog: (state) => {
      state.open = false;
      state.onConfirm = undefined;
      state.onCancel = undefined;
    },
  },
});

export const { showAlertDialog, closeAlertDialog } = alertDialogSlice.actions;

export default alertDialogSlice.reducer;
